<template>
    <div class="pagination">
        <!--上一页下一页-->
        <div class="page-btn hd">
            <div class="btn" v-show="prevnext">
                <a href="javascript:;" @click="prevPage()">上一页</a>
                <a href="javascript:;" @click="nextPage()">下一页</a>
            </div>
            <div class="page flard fr">
                <div class="zuo">
                    <img src="../assets/search/lf.png" @click="prevPage()" alt=""/>
                </div>
                <p class="dqye"><input type="text" class="page-num" :value="pcurrentPage" @keyup.enter="updatePageNum($event)" @blur="updatePageNum($event)"></p>
                <div class="you">
                    <img src="../assets/search/lf.png" @click="nextPage()" alt=""/>
                </div>
                <div class="allpage">
                    <span>总页数{{ptotal}}页</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Pagination',
        props:['pcurrentPage','ptotal','prevnext'],

        data() {
            return {
                havecurrentPage: this.pcurrentPage,
                htotal: this.ptotal,
                hprevnext: this.prevnext,
                keyword:'',
                user_id:'',
                type:'',
                page_type:1,
            }
        },
        created() {
            this.$get('/me')
                .then( res => {
                    if(res.code == 200){
                        this.user_id = res.data.user.id
                    }
                }).catch(error => {
                console.log(error)
            })
        },
        mounted() {
        },
        watch: {
            prevnext(val) {
                this.hprevnext = val;
            },
            ptotal(val) {
                this.htotal = val;
            },
            pcurrentPage(val) {
                if(val < 1){
                    this.havecurrentPage = 1
                }else{
                    this.havecurrentPage = val
                }
            },
            havecurrentPage(val){
                this.$emit("on-result-change",val);
            }
        },
        methods: {
            updatePageNum(e){
                console.log(e.currentTarget.value)
                this.pcurrentPage = e.currentTarget.value
                this.keyword = this.$route.query.keyword
                this.type = this.$route.query.mediaType
                let data = {
                    keywords:this.keyword,
                    user_id:this.user_id,
                    type:this.type,
                    page_type:this.page_type,
                    current_page:this.pcurrentPage
                }
                this.$post('/es/touchDetail',data)
                    .then( res => {
                    }).catch(errors => {
                    console.log(errors);
                })

            },
            prevPage(){
                if(this.pcurrentPage > 1){
                    this.pcurrentPage--;
                    this.keyword = this.$route.query.keyword
                    this.type = this.$route.query.mediaType
                    let data = {
                        keywords:this.keyword,
                        user_id:this.user_id,
                        type:this.type,
                        page_type:this.page_type,
                        current_page:this.pcurrentPage
                    }
                    this.$post('/es/touchDetail',data)
                        .then( res => {
                        }).catch(errors => {
                        console.log(errors);
                    })
                }
            },
            nextPage(){
                if(this.pcurrentPage < this.ptotal){
                    this.pcurrentPage++;
                }
                this.keyword = this.$route.query.keyword
                this.type = this.$route.query.mediaType
                let data = {
                    keywords:this.keyword,
                    user_id:this.user_id,
                    type:this.type,
                    page_type:this.page_type,
                    current_page:this.pcurrentPage
                }
                this.$post('/es/touchDetail',data)
                    .then( res => {
                    }).catch(errors => {
                    console.log(errors);
                })
            },
        }
    }
</script>

<style scoped>
    .btn{width:285px;margin: 0 auto }
    .btn a{display: inline-block;width: 130px;height: 40px;line-height: 40px;border-radius: 23px;text-align: center;border: 1px solid#000;font-size:18px;margin: 0 5px;}
    .page{font-size: 14px;}
    .page .dqye{width: 50px;border-bottom: 1px solid #000000;text-align: center;font-weight: 600;}
    .zuo img,.you img{width: 14px;height: 14px;cursor: pointer;}
    .you img{transform: rotate(180deg); -webkit-transform: rotate(180deg)}
    .allpage{margin: 0 10px;}
    .page-btm{margin-top: -30px;}
    .page-num{width: 50px;height: 18px;text-align: center;padding: 0}
</style>